import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "cx-sid";

let lastSent = { path: null, at: 0 };

// Privacy-light visit counter: one random id per browser session, page path,
// nothing else. Powers the owner's daily report.
export default function VisitTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    // guard against React StrictMode double-invoke / instant re-mounts
    const now = Date.now();
    if (lastSent.path === pathname && now - lastSent.at < 5000) return;
    lastSent = { path: pathname, at: now };
    let sid = sessionStorage.getItem(SID_KEY);
    if (!sid) {
      sid = crypto.randomUUID();
      sessionStorage.setItem(SID_KEY, sid);
    }
    axios.post(`${API}/track`, { sid, path: pathname }).catch(() => {});
  }, [pathname]);

  return null;
}
